var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquarearrowupright24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Cloud/24/Open",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.25 13.673v2.002c0 1.243-.13 1.694-.372 2.148-.243.455-.6.812-1.055 1.055-.454.243-.905.372-2.148.372h-7.35c-1.243 0-1.694-.13-2.148-.372a2.534 2.534 0 01-1.055-1.055c-.243-.454-.372-.905-.372-2.148v-7.35c0-1.243.13-1.694.372-2.148.243-.455.6-.812 1.055-1.055.454-.243.905-.372 2.148-.372h2.002",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    d: "M19 5l-7 7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    strokeLinejoin: "round",
    d: "M14.75 4.75h4.5v4.5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquarearrowupright24);
export default __webpack_public_path__ + "static/media/square.arrow.up.right-24.174915c6.svg";
export { ForwardRef as ReactComponent };